import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoModelloDichiarativoStep2Component } from './conservazione-carica-documento-modello-dichiarativo-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-modello-dichiarativo-step2', {
            url: '/conservazione-carica-modello-dichiarativo',
            ncyBreadcrumb: {
                label: 'Carica Modelli Dichiarativi',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-modello-dichiarativo-step2 flex="100"></conservazione-carica-documento-modello-dichiarativo-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoModelloDichiarativoStep2Module: string = ng
    .module('conservazione-carica-documento-modello-dichiarativo-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoModelloDichiarativoStep2', ConservazioneCaricaDocumentoModelloDichiarativoStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-dichiarativo-step2/conservazione-carica-documento-modello-dichiarativo-step2.module.ts